import React from 'react';

import DocumentMeta from 'react-document-meta';

class ShippingReturn extends React.Component {
	render() {

		const meta = {
			title:          'Levering & Returnering – Alaska Cykler',
			description:    'Læs om levering, returret, tilbagebetaling og reklamation hos Alaska Cykler.',
			canonical:      window.location.href,
			meta: {
				charset:    'utf-8',
				name: {
					keywords: 'alaska cykler levering, returret, fortrydelsesret, reklamation'
				}
			}
		};

		return (
			<div className="main-content" id="policy-page">

				<DocumentMeta {...meta} />

				<div className="container policy-container">
					<header className="header header-main text-left row">
						<h2 className="col-md-12 text-left">
							Levering &amp; Returnering
							<p>Leverings- og returpolitik – Alaska Cykler</p>
						</h2>
					</header>

					<div className="row">
						<div className="col-md-10">

							<h3 className="sec-head">Levering</h3>
							<p>Alaska Cykler tilbyder levering efter aftale. Leveringsmuligheder, leveringstid og eventuelle fragtomkostninger afhænger af varen og leveringsadressen.</p>
							<p>Eventuelle leveringsomkostninger oplyses til kunden inden bestillingens bekræftelse.</p>
							<p>For spørgsmål om levering er du velkommen til at kontakte os.</p>

							<h3 className="sec-head">Returnering</h3>
							<p>Alaska Cykler tilbyder 14 dages returret på køb foretaget online i overensstemmelse med gældende dansk lovgivning.</p>
							<p>Varen skal returneres ubrugt og i forsvarlig stand. Kunden bedes kontakte os inden returnering for at aftale den praktiske fremgangsmåde.</p>
							<p>Ved brug af den lovbestemte fortrydelsesret gælder de almindelige regler for returnering og tilbagebetaling. Eventuelle fradrag for værdiforringelse sker i overensstemmelse med gældende lovgivning.</p>
							<p>Ved køb i vores fysiske butik gælder der ikke automatisk 14 dages fortrydelsesret, medmindre andet er aftalt. Den lovbestemte reklamationsret gælder fortsat.</p>

							<h3 className="sec-head">Tilbagebetaling</h3>
							<p>Tilbagebetaling sker i overensstemmelse med gældende dansk lovgivning, når betingelserne for fortrydelse eller tilbagebetaling er opfyldt.</p>

							<h3 className="sec-head">Beskadigede eller defekte varer</h3>
							<p>Hvis du modtager en beskadiget, defekt eller forkert vare, bedes du kontakte os hurtigst muligt, så vi kan hjælpe med at løse problemet.</p>

						</div>
					</div>
				</div>

			</div>
		);
	}
}

export default ShippingReturn;




// WEBPACK FOOTER //
// ./src/Pages/ShippingReturn.js